const SET_OPEN_INLINE_POPUP = 'set-open-inline-popup';

export { SET_OPEN_INLINE_POPUP };
